module.exports = __webpack_public_path__ + "static/media/14UNEP4.d5443681.jpg";